<template lang="pug">
  main.main.main_cancel-success
    header.main__header
      h1.main__title {{ $t('video-cancel.title') }}
    .main__container
      .main__content
        .main__button
          a.button(@click="$router.push({ path: '/video' })") {{ $t('video-cancel.button') }}
</template>

<script>
export default {
  name: 'Video_Cancel'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Video/Video_Cansel.vue